var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "sfcNormalNodeContent",
        style: { background: _vm.data.nodeColor },
        on: {
          click: function ($event) {
            return _vm.openDialog(_vm.data)
          },
          mouseenter: function ($event) {
            $event.stopPropagation()
            return _vm.onMouseenter(_vm.data)
          },
          mouseleave: function ($event) {
            $event.stopPropagation()
            return _vm.onMouseleave($event)
          },
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "sfcNormalNodeTitle",
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
            },
          },
          [
            _c("div", [_vm._v(" " + _vm._s(_vm.data.code || "") + " ")]),
            _c("div", [_vm._v(" " + _vm._s(_vm.data.title || "") + " ")]),
          ]
        ),
        _c("div", { staticClass: "sfcNormalNodeData" }, [
          _c(
            "div",
            {
              staticClass: "sfcNormalNodeDataText",
              style: {
                display: "flex",
                flexDirection: "column",
                height: "100px", // 固定高度，可按需调整
                overflowY: _vm.data.typeLength > 1 ? "auto" : "hidden", // 内容过多时显示滚动条
                paddingRight: "70px",
              },
            },
            [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.data.type || "") },
              }),
              _c("div", [_vm._v("数量:" + _vm._s(_vm.data.qty || ""))]),
            ]
          ),
        ]),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "margin-top": "10px",
            },
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.getInfoNode(_vm.data)
                      },
                    },
                  },
                  [_vm._v("查看")]
                ),
              ],
              1
            ),
            _vm.data.nodeDataList.traceModeCode !== "apiTrace"
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.operateNode(_vm.data)
                          },
                        },
                      },
                      [_vm._v("采集")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
    _c(
      "div",
      [
        _c(
          "el-dialog",
          {
            attrs: {
              title: "序列号列表",
              visible: _vm.outerVisible,
              width: "800px",
              "append-to-body": "",
              "close-on-press-escape": "",
              "close-on-click-modal": false,
              "close-on-press-escape": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.outerVisible = $event
              },
              closed: _vm.closeEvent,
            },
          },
          [
            _c(
              "el-dialog",
              {
                attrs: {
                  visible: _vm.innerVisible,
                  title: "采集项列表",
                  width: "670px",
                  "append-to-body": "",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.innerVisible = $event
                  },
                },
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "wl-dialog-form flex-direction-column",
                    staticStyle: { padding: "5px" },
                    attrs: {
                      disabled: true,
                      model: _vm.form,
                      "label-width": "70px",
                    },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "编码" } },
                              [
                                _c("el-input", {
                                  staticStyle: { height: "100%" },
                                  model: {
                                    value: _vm.form.stationCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "stationCode", $$v)
                                    },
                                    expression: "form.stationCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "名称" } },
                              [
                                _c("el-input", {
                                  staticStyle: { height: "100%" },
                                  model: {
                                    value: _vm.form.stationName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "stationName", $$v)
                                    },
                                    expression: "form.stationName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "模型" } },
                              [
                                _c("el-input", {
                                  staticStyle: { height: "100%" },
                                  model: {
                                    value: _vm.form.traceModeName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "traceModeName", $$v)
                                    },
                                    expression: "form.traceModeName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.innerGridData,
                      border: "",
                      height: "360",
                      stripe: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: "序号",
                        width: "50",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "itemCode",
                        label: "采集项编码",
                        width: "140",
                        "header-align": "center",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "itemName",
                        label: "名称",
                        width: "180",
                        "header-align": "center",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "itemValue",
                        label: "值",
                        width: "180",
                        "header-align": "center",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "itemTypeName",
                        label: "类型",
                        width: "80",
                        "header-align": "center",
                        "show-overflow-tooltip": true,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "wl-dialog-form flex-direction-column",
                staticStyle: { padding: "5px" },
                attrs: {
                  disabled: true,
                  model: _vm.form,
                  "label-width": "70px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "编码" } },
                          [
                            _c("el-input", {
                              staticStyle: { height: "100%" },
                              model: {
                                value: _vm.form.stationCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "stationCode", $$v)
                                },
                                expression: "form.stationCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "名称" } },
                          [
                            _c("el-input", {
                              staticStyle: { height: "100%" },
                              model: {
                                value: _vm.form.stationName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "stationName", $$v)
                                },
                                expression: "form.stationName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "模型" } },
                          [
                            _c("el-input", {
                              staticStyle: { height: "100%" },
                              model: {
                                value: _vm.form.traceModeName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "traceModeName", $$v)
                                },
                                expression: "form.traceModeName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tabs",
              {
                attrs: { type: "border-card" },
                on: { "tab-click": _vm.tabsClick },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      name: "artificialTrace",
                      label: _vm.data.artificialType,
                    },
                  },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.gridData,
                          border: "",
                          height: "360",
                          stripe: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "index",
                            label: "序号",
                            width: "50",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sequence",
                            label: "序列号",
                            width: "220",
                            "header-align": "center",
                            "show-overflow-tooltip": true,
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "createByName",
                            label: "采集人",
                            width: "140",
                            "header-align": "center",
                            "show-overflow-tooltip": true,
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "collectTime",
                            label: "采集时间",
                            width: "180",
                            "header-align": "center",
                            "show-overflow-tooltip": true,
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stackCode",
                            label: "托盘条码",
                            width: "80",
                            "header-align": "center",
                            "show-overflow-tooltip": true,
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "operateName",
                            label: "操作",
                            width: "80",
                            align: "center",
                            "show-overflow-tooltip": true,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClick(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { float: "right", "margin-top": "10px" } },
                      [
                        _c("el-pagination", {
                          attrs: {
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.paginationObj.total,
                            "current-page": _vm.paginationObj.currentPage,
                            "page-sizes": _vm.paginationObj.pageSizes,
                            "page-size": _vm.paginationObj.pageSize,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._l(_vm.data.apiList, function (apiItem, index) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: index,
                      attrs: {
                        name: "apiTrace",
                        label: apiItem.traceModeName,
                        name: "apiTrace_" + index,
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.apiGridData[index],
                            border: "",
                            height: "360",
                            stripe: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              label: "序号",
                              width: "50",
                              align: "center",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sequence",
                              label: "序列号",
                              width: "220",
                              "header-align": "center",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "createByName",
                              label: "采集人",
                              width: "140",
                              "header-align": "center",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "collectTime",
                              label: "采集时间",
                              width: "180",
                              "header-align": "center",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "stackCode",
                              label: "托盘条码",
                              width: "80",
                              "header-align": "center",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "operateName",
                              label: "操作",
                              width: "80",
                              align: "center",
                              "show-overflow-tooltip": true,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.apiHandleClick(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("查看")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { float: "right", "margin-top": "10px" },
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.apiPaginationObj[index].total,
                              "current-page":
                                _vm.apiPaginationObj[index].currentPage,
                              "page-sizes":
                                _vm.apiPaginationObj[index].pageSizes,
                              "page-size": _vm.apiPaginationObj[index].pageSize,
                            },
                            on: {
                              "size-change": function ($event) {
                                return _vm.apiHandleSizeChange(index, $event)
                              },
                              "current-change": function ($event) {
                                return _vm.apiHandleCurrentChange(index, $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }